function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';
import { StyledIcon } from '../StyledIcon';
export var Secure = function Secure(props) {
  return React.createElement(StyledIcon, _extends({
    viewBox: "0 0 130 130",
    a11yTitle: "Secure"
  }, props), React.createElement("style", {
    type: "text/css"
  }), React.createElement("path", {
    "class": "st0",
    d: "M118.13,21.5L69.66,1.3c-2.98-1.24-6.34-1.24-9.32,0L11.87,21.5c-4.52,1.88-7.46,6.29-7.46,11.19 c0,50.11,28.9,84.75,55.93,96.01c2.98,1.24,6.34,1.24,9.32,0c21.61-9,55.93-40.15,55.93-96.01 C125.59,27.79,122.65,23.38,118.13,21.5z M66.55,121.24c-1,0.4-2.11,0.4-3.11,0c-24.7-9.79-50.96-44.12-50.96-88.55 c0-1.64,0.98-3.1,2.49-3.73l48.47-20.2c0.99-0.41,2.11-0.41,3.11,0l48.47,20.2c1.51,0.62,2.49,2.1,2.49,3.73 C117.51,77.12,91.25,111.45,66.55,121.24z M103.07,45.63l-45.56,45.2C56.32,92,54.4,92,53.23,90.81L31.55,68.95 c-1.18-1.19-1.17-3.11,0.02-4.28l2.15-2.13c1.19-1.18,3.11-1.17,4.28,0.02l17.41,17.55l41.26-40.93c1.19-1.18,3.11-1.17,4.28,0.02 l2.13,2.15C104.27,42.53,104.26,44.45,103.07,45.63L103.07,45.63z"
  }));
};